//AUTHENTICATIONS
export const ADMIN_LOGIN = "auth/login";
export const FORGOT_PASSWORD = "auth/forgot-password";
export const CHANGE_PASSWORD = "auth/change-password";

//HEADER
export const CREATE_HEADER_TEMPLATE = "email-craft/create-template-header";
export const EDIT_HEADER_TEMPLATE = "email-craft/update-template-header";
export const HEADER_LISTING = "email-craft/template-headers";
export const HEADER_TEMPLATE_SINGLE_LISTING = "email-craft/template-header/";
export const STATUS_UPDATE_HEADER = "email-craft/template-header/enable-or-disable";
export const DELETE_HEADER_TEMPLATE = "email-craft/destroy-template-header";

//TEMPLATE
export const CREATE_TEMPLATE = "email-craft/create-template";
export const EDIT_TEMPLATE = "email-craft/update-template";
export const TEMPLATE_LISTING = "email-craft/templates";
export const HEADER_LISTING_PAGINATE = "email-craft/template-header-dropdown";
export const FOOTER_LISTING_PAGINATE = "email-craft/template-footer-dropdown";
export const TEMPLATE_SINGLE_LISTING = "email-craft/template/";
export const STATUS_UPDATE_TEMPLATE = "email-craft/template/enable-or-disable";
export const DELETE_TEMPLATE = "email-craft/destroy-template";
export const SUBMIT_IMAGE_TEMPLATE = "media/upload-media";

//FOOTER
export const CREATE_FOOTER_TEMPLATE = "email-craft/create-template-footer";
export const EDIT_FOOTER_TEMPLATE = "email-craft/update-template-footer";
export const FOOTER_LISTING = "email-craft/template-footer";
export const FOOTER_TEMPLATE_SINGLE_LISTING = "email-craft/template-footer/";
export const STATUS_UPDATE_FOOTER = "email-craft/template-footer/enable-or-disable";
export const DELETE_FOOTER_TEMPLATE = "email-craft/destroy-template-footer";

//REPORT
export const ERROR_REPORT_LISTING = "email-craft/template-error-logs/";
export const SENT_REPORT_LISTING = "email-craft/email-dispatch-logs/";
